import branchMgmtDailyBalanceSheetComponent from './daily_balance_sheet.component';
import dailyBalanceSheetPrintModule from './print'

let branchMgmtDailyBalanceSheetModule = angular.module('branchMgmtDailyBalanceSheet', [
  dailyBalanceSheetPrintModule
])
  .component('branchMgmtDailyBalanceSheet', branchMgmtDailyBalanceSheetComponent)
  .name;

export default branchMgmtDailyBalanceSheetModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/daily_balance_sheet/index.js